import {
  CURRENCY_SYMBOLS,
  EUR_SEK_EXCHANGE_RATE,
  HTML_TAG_PATTERN,
  SEK_AMOUNT_PATTERN,
  SPACE_PATTERN,
  SUB_UNIT_DECIMALS,
} from '@layers/web/constants/currency.ts'

const currencySymbol = (market: string, showEurPricing: boolean): string =>
  showEurPricing ? CURRENCY_SYMBOLS.eur : CURRENCY_SYMBOLS[market] ?? CURRENCY_SYMBOLS.sv

const sekToEur = (value: number): number => value / EUR_SEK_EXCHANGE_RATE

const eurToSek = (value: number): number => Math.round(value * EUR_SEK_EXCHANGE_RATE)

const priceChangeFormatOptions = (
  sek: number,
  showEurPricing: boolean
): { precision?: number } =>
  showEurPricing && Math.abs(sekToEur(sek)) < 1 ? { precision: SUB_UNIT_DECIMALS } : {}

const parseSekAmount = (amount: string): number =>
  Number(amount.replace(SPACE_PATTERN, '').replace(',', '.'))

const replaceSekAmounts = (text: string, format: (sek: number) => string): string =>
  text.replace(
    SEK_AMOUNT_PATTERN,
    (_match, before: string, integers: string, decimals = '') =>
      `${before}${format(parseSekAmount(`${integers}${decimals}`))}`
  )

const convertSekAmountsInText = (text: string, format: (sek: number) => string): string =>
  text
    .split(HTML_TAG_PATTERN)
    .map(part => part.startsWith('<') ? part : replaceSekAmounts(part, format))
    .join('')

export {
  currencySymbol,
  sekToEur,
  eurToSek,
  priceChangeFormatOptions,
  convertSekAmountsInText,
}
